import { API_URL } from "../../../../utils/apiConfig";

export const RegulationsApi = () => {
    return  API_URL+"api/regulations";
}
